module.exports = __webpack_public_path__ + "media/images/icons/event-4d98fa510eeb01f7366ee421c3f43c37.svg";